const BASE_SESSION_KEYS = [
  'token',
  'otp_verified',
  'is_aic_one_login',
  'auth_redirect_reason',
  'current_user_id',
  'current_lead_id',
  'current_role',
  'current_lead_name',
];

const LAND_COURT_SESSION_KEYS = [
  'land_court_entity_type_id',
  'land_court_case_meta',
];

const LAND_COURT_SESSION_PREFIXES = [
  'land_court_caseload_snapshot:',
];

const remove_session_key = (key) => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(key);
};

const set_session_value = (key, value) => {
  if (typeof window === 'undefined') return;

  if (value === null || value === undefined || value === '') {
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, String(value));
};

const remove_prefixed_session_keys = (prefixes = []) => {
  if (typeof window === 'undefined') return;

  Object.keys(sessionStorage)
    .filter((key) => prefixes.some((prefix) => key.startsWith(prefix)))
    .forEach((key) => sessionStorage.removeItem(key));
};

export const clear_auth_redirect_state = () => {
  remove_session_key('auth_redirect_reason');
  remove_session_key('otp_verified');
};

export const set_login_session = ({
  token,
  is_aic_one_login = false,
  land_court_entity_type_id = null,
} = {}) => {
  set_session_value('token', token);
  set_session_value('is_aic_one_login', is_aic_one_login);
  set_session_value('land_court_entity_type_id', land_court_entity_type_id);
  clear_auth_redirect_state();
};

export const clear_auth_session = ({ include_land_court = true } = {}) => {
  BASE_SESSION_KEYS.forEach(remove_session_key);

  if (include_land_court) {
    LAND_COURT_SESSION_KEYS.forEach(remove_session_key);
    remove_prefixed_session_keys(LAND_COURT_SESSION_PREFIXES);
  }
};

export default {
  clear_auth_redirect_state,
  clear_auth_session,
  set_login_session,
};
